import { useState, useEffect } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/logo/Remove_the_background_from_this_logo_image_make_i-1774710035371.png';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const handleNav = (section) => {
    setOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        if (section === 'hero') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          const el = document.getElementById(section);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      if (section === 'hero') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        const el = document.getElementById(section);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <>
      <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
        <div className="container nav__inner">

          <button className="nav__logo" onClick={() => handleNav('hero')}>
            <img src={logo} alt="Rremi Rent a Car" />
          </button>

          <nav className="nav__links">
            <button className="nav__link" onClick={() => handleNav('hero')}>Kreu</button>
            <button className="nav__link" onClick={() => handleNav('fleet')}>Flotë</button>
            <button className="nav__link" onClick={() => handleNav('about')}>Rreth Nesh</button>
            <button className="nav__link" onClick={() => handleNav('contact')}>Kontakti</button>
          </nav>

          <a href="tel:+38343888408" className="nav__cta">
            <Phone size={15} />
            <span className="nav__cta-text">+383 43 888 408</span>
          </a>

          <button className="nav__burger" onClick={() => setOpen(o => !o)} aria-label="Menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>

        </div>
      </header>

      <div className={`nav__drawer ${open ? 'nav__drawer--open' : ''}`}>
        <button className="nav__drawer-link" onClick={() => handleNav('hero')}>Kreu</button>
        <button className="nav__drawer-link" onClick={() => handleNav('fleet')}>Flotë</button>
        <button className="nav__drawer-link" onClick={() => handleNav('about')}>Rreth Nesh</button>
        <button className="nav__drawer-link" onClick={() => handleNav('contact')}>Kontakti</button>
        <a href="tel:+38343888408" className="nav__drawer-phone">
          <Phone size={16} /> +383 43 888 408
        </a>
      </div>
    </>
  );
}